import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { SetPasswordService } from './setpassword.service';
import { NgClass } from '@angular/common';
import * as Materialize from 'angular2-materialize';
import { ProjectDataService } from '../shared/dataservice.service';
import { NavbarService } from '../navbar/navbar.service';

@Component({
  selector: 'app-setpassword',
  templateUrl: 'setpassword.component.html',
  styleUrls: ['setpassword.component.css'],
  providers: [SetPasswordService]

})
export class SetpasswordComponent implements OnInit, OnDestroy {

  email: string = '';
  message: string = '';
  oldpassword: string = '';
  newpassword: string = '';
  confirmpassword: string = '';
  loginicon = '';
  sub: any;

  constructor(private SetPasswordService: SetPasswordService,
              private router: Router,
              private route: ActivatedRoute,
              public navService: NavbarService) { }

  ngOnInit() {
    this.navService.hide();
    this.sub = this.route.params.subscribe(params => {
      this.email = params['email'];
      this.oldpassword = params['code'];
    });
  }

  ngOnDestroy() {
  }

  onSetPassword() {
    console.log('onSetPassword() clicked');
    this.message = null;

    // Trim the entered password
    this.oldpassword.trim();

    if (!this.oldpassword || !this.newpassword || !this.confirmpassword) {
      this.message = 'All fields are required';
      return;
    }

    if (this.newpassword != this.confirmpassword) {
      this.message = 'Entered new passwords do not match';
      return;
    }

     if (this.newpassword.length < 8) {
      this.message = 'Password must be a minimum of 8 characters in length';
      return;
    }

    this.loginicon = 'fa right fa-spinner fa-pulse';
    (<HTMLInputElement>document.getElementById('setPasswordBtn')).disabled = true;

    this.message = null;
    this.SetPasswordService.setPassword(this.email, this.oldpassword, this.newpassword).subscribe(

      data => {
          console.log('DATA:', data);
          this.loginicon = '';
          (<HTMLInputElement>document.getElementById('setPasswordBtn')).disabled = false;

          let json: any = data;

          if ( json.hasOwnProperty('errorMessage') ) {
            this.message = json.errorMessage;
            console.error('ERROR: ' + this.message);
          } else {
            console.log('Password updated');
            Materialize.toast('PASSWORD UPDATED SUCCESSFULLY', 2000);
            this.router.navigate(['/login']);
          }
      },
      error => {
        console.error('ERROR:', error);
        this.loginicon = '';
        (<HTMLInputElement>document.getElementById('setPasswordBtn')).disabled = false;

        console.error('result: ' + error);

        this.message = error;
        console.error('ERROR: ' + this.message);
      });

    return;
  }

  toLogin() {
    this.router.navigate(['/login']);
  }
}



// WEBPACK FOOTER //
// /Users/mark/Documents/Source/MachineResearch/MR2/angular2/src/app/setpassword/setpassword.component.ts